export default __webpack_public_path__ + "static/media/logo138x75black.fbc4ec31.png";